export default __webpack_public_path__ + "static/media/login.fc2261bc.jpg";